/**
 * @author: subhasish.ghosh@zoom.us
 */

import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@utils/axiosInstance";
import React from "react";

export const useProfile = () =>
  useQuery({
    queryKey: "user-action-data",
    queryFn: async () => {
      try {
        return await axiosInstance.get("/operationmonitor/api/v1/user");
      } catch (error) {
        console.error("Error fetching User Info:", error);
      }
    },
    ...{
      refetchOnWindowFocus: true,
      refetchInterval: 5 * 60 * 1000, // 5 minutes
      staleTime: 5 * 60 * 1000,
    },
  });
